import { map } from 'rxjs/operators';
import { filter, Observable, of } from 'rxjs';
import { Supplier, SupplierNameGQL, Maybe } from '@iss/libs/graphql';
import {
  ChangeDetectorRef,
  inject,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';

@Pipe({ name: 'supplierName', pure: false, standalone: true })
export class SupplierNamePipe implements PipeTransform, OnDestroy {
  private readonly supplierName = inject(SupplierNameGQL);
  private readonly asyncPipe = new AsyncPipe(inject(ChangeDetectorRef));
  private id?: Maybe<Supplier['id']>;
  private supplierName$!: Observable<string | null>;

  public transform(id: Maybe<Supplier['id']>): string | null {
    if (this.id !== id) {
      this.id = id;
      this.supplierName$ = id ? this.fetch(id) : of(null);
    }

    return this.asyncPipe.transform(this.supplierName$);
  }

  public ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  protected fetch(id: Supplier['id']): Observable<string> {
    return this.supplierName.fetch({ id }).pipe(
      map(({ data }) => data),
      filter(Boolean),
      map(({ supplier }) => supplier.organization.name),
    );
  }
}
